import { render, staticRenderFns } from "./ListEquipmentTransferPage.vue?vue&type=template&id=18a4fe5a"
import script from "./ListEquipmentTransferPage.vue?vue&type=script&lang=js"
export * from "./ListEquipmentTransferPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports